<template>
  <sdCards :title="$t('pages.apps.release.title')">
    <a-table :columns="columns" :data-source="data" size="small">
      <template #action="{ record }">
        <a-space>
          <a-button @click="editNote(record.key)" type="primary">
            <template #icon> <sdFeatherIcons type="edit" /> </template>
          </a-button>
        </a-space>
      </template>
    </a-table>
  </sdCards>

  <a-modal v-model:visible="modalVisible" :title="$t('pages.apps.release.edit-release')" :footer="null">
    <a-form layout="vertical" :model="formData" @submit="saveData">
      <a-form-item :label="$t('pages.apps.release.desc')">
        <a-textarea v-model:value="formData.text" :placeholder="$t('pages.apps.release.desc')" :rows="2" required/>
      </a-form-item>
      <a-form-item :label="$t('pages.apps.release.desc-en')">
        <a-textarea v-model:value="formData.text_en" :placeholder="$t('pages.apps.release.desc-en')" :rows="2" required/>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" :loading="iconLoading" html-type="submit"> {{ $t('common.save') }} </a-button>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { dateToTr } from '@/utility/helper';

export default {
  name: 'ReleaseNotes',
  data() {
    return {
      modalVisible: false,
      allData: [],
      iconLoading: false,
      formData: {
        id: null,
        text: null,
        text_en: null,
        app_id: this.$route.params.id,
      },
      app_id: this.$route.params.id,
      data: [],
      columns: [
        {
          dataIndex: 'app_version',
          key: 'app_version',
          title: this.$t('common.version'),
        },
        {
          dataIndex: 'text',
          key: 'text',
          title: this.$t('pages.apps.release.desc'),
          ellipsis: true,
        },
        {
          dataIndex: 'text_en',
          key: 'text_en',
          title: this.$t('pages.apps.release.desc-en'),
          ellipsis: true,
        },
        {
          dataIndex: 'admin_note',
          key: 'admin_note',
          title: this.$t('pages.apps.release.admin_note'),
        },
        {
          dataIndex: 'date',
          key: 'date',
          title: this.$t('common.date'),
        },
        {
          title: this.$t('common.action'),
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  methods: {
    editNote(index) {
      const data = this.allData[index];
      this.formData.id = data.id;
      this.formData.text = data.text;
      this.formData.text_en = data.text_en;
      this.modalVisible = true;
    },
    saveData() {
      this.$appAxios.post(this.$endpoints.releaseNotes_update, this.formData).then((resp) => {
        if (resp.data.status) {
          this.$message.success(this.$t('common.success-message'));
          this.getData();
          this.formData.text = null;
          this.formData.text_en = null;
          this.modalVisible = false;
        } else {
          this.$message.error(resp.data.message);
        }
      });
    },
    getData() {
      this.data = [];
      const formData = {
        app_id: this.app_id,
      };
      this.$appAxios.post(this.$endpoints.releaseNotes_getByApp, formData).then((resp) => {
        if (resp.data.status) {
          this.allData = resp.data.data;
          var _this = this;
          this.allData.forEach(function (item, index) {
            _this.data.push({
              key: index,
              id: item.id,
              text: item.text,
              text_en: item.text_en,
              admin_note: item.admin_note,
              date: dateToTr(item.date),
              app_version: item.app_version,
            });
          });
        }
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>